import { render } from "./AccountComparisonTable.vue?vue&type=template&id=ee153b1c&scoped=true"
import script from "./AccountComparisonTable.vue?vue&type=script&lang=js"
export * from "./AccountComparisonTable.vue?vue&type=script&lang=js"

import "./AccountComparisonTable.vue?vue&type=style&index=0&id=ee153b1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee153b1c"]])

export default __exports__